import { FC, PropsWithChildren } from 'react';

import { Box, HStack, Tooltip, VStack } from '@bonusly/design-system';

import { useModKey } from './hooks/use-mod-key';
import { KeyBox } from './key-box';

interface ControlTooltipProps extends PropsWithChildren {
	label: string;
	keys?: string | string[];
}

export const ControlTooltip: FC<ControlTooltipProps> = ({ children, label, keys = [] }) => {
	const command = useModKey();
	const keyList = typeof keys === 'string' ? keys.split(' ') : keys;
	keyList.unshift(command);

	return (
		<Tooltip
			label={
				<VStack spacing={1}>
					<Box>{label}</Box>
					{keys.length > 1 && (
						<HStack alignItems="center" spacing={1}>
							{keyList.map((key, i) => (
								<KeyBox key={i}>{key}</KeyBox>
							))}
						</HStack>
					)}
				</VStack>
			}
		>
			{children}
		</Tooltip>
	);
};
